if (!window.creditSlotHandler) {

    const creditSlotHandler = {
        handleCreditPage(event, isSlotMounted = false) {
            console.warn('handleCreditPage init')
            if (isSlotMounted) {
                console.warn('handleCreditPage init2')
                this.handleMountedSlots(event)
            }
        },
        async getCreditSummery() {
            const sessionRecharge = await recharge.auth.loginCustomerPortal();
            const response = await recharge.credit.getCreditSummary(sessionRecharge, { include: ['credit_details'] });
            window.creditSummary = response
            return response
        },
        deintializeCreditPage() {
            $('#creditHeaderSlot').hide();
            $('#creditFooterSlot').hide();
        },
        handleMountedSlots(event) {
            const slotName = event.detail.name;
            switch (slotName) {
                case 'header':
                    this.handleCreditHeaderSlot();
                case 'footer':
                    this.handleCreditFooterSlot();
                    break;
            }
        },
        async handleCreditHeaderSlot() {
            console.log('slot initialize')
            $('#recharge-customer-portal').addClass('creditHeaderSlot');
            const creditHtml = await this.fetchRewardPageHtml();
            if (creditHtml) {
                $('#recharge-customer-portal').addClass('creditHeaderSlot');
                $('#recharge-customer-portal div[data-testid="slot-header"]').next()
                    .children()
                    .eq(0) // Select the first child inside the next div
                    .after(creditHtml);

                setTimeout(() => {
                    console.warn('trigger')
                    // handleMobileRechargeMenu()
                    this.showProgramBadgeMobileNav()
                    // equalizeCardHeights()
                    this.handleHideJoinButton();

                    if (window?.sessionRecharge) {
                        // dispatch event customer logged in done
                        const customerLoggedInEvent = new CustomEvent("customerRechargeLoggedIn", {
                            detail: {
                                sessionRecharge: window.sessionRecharge,
                            },
                        });
                        document.dispatchEvent(customerLoggedInEvent);
                    }
                }, 400)
            } else console.log('Something wrong on hanldeCreditHeaderSlot');
        },

        handleHideJoinButton() {
            $('.rich-text-custom').eq(4).remove();

        },
        async showProgramBadgeMobileNav() {
            if (window.innerWidth > 768) return
            const programColor = $('.topSectionWrapperDynamic .programName').attr('data-program-color');
            const programName = $('.topSectionWrapperDynamic .programName').attr('data-program-name');
            if ($('.previewText .previewTextProgramName').length == 0) {
            //     $('.customMobileNavigation .previewText').append(`
            //     <span class="previewTextProgramName" style="margin-left: auto;float: right;padding: 9px 11px;right: -4px;top: -8px;border-radius: 4px;font-size: 12px;line-height: 1;text-tranform:capitalize;color:black"> ${programName}</span>
            // `);
                $('.previewTextProgramName').css('background', programColor);
            }
        },

        async fetchRewardPageHtml() {
            const response = await fetch(`/pages/rewards/${window.innerWidth <= 768 ? 'from=CustomerPortal' : ''}`);
            const htmlText = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlText, 'text/html');
            const newPageContent = doc.querySelector('#main-content');
            const shopifySections = newPageContent.querySelectorAll('.shopify-section');
            shopifySections.forEach(section => {
                // section.classList.add('myAccount');
            });

            newPageContent.querySelector('.reward-top-section').remove();
            // newPageContent.querySelector('.f').remove();
            // newPageContent.querySelector('.reward-top-section-logged-in .title').remove();
            newPageContent.querySelector('.reward-top-section-logged-in img')?.remove();

            return newPageContent ? newPageContent.innerHTML : false;
        },

        getCreditSectionHTML(creditSummary) {
            return `
         <div id="creditHeaderSlot" style="display:block;">
                 ${this.getCreditHeaderHTML(creditSummary.total_available_balance)}
                 <div class="extra-text">
                 <p> Welcome to the new Expert Rewards program. </p>
                 <p> Earn 5% Cash Back on all orders.</p>
                 <p> Redeem Cash Back in the portal, no coupons needed.</p>
                 <p> Redeem Cash Back at checkout for regular orders.</p>
                 <p> Earn extra rewards and discounts which will appear in the portal.</p>
                 <p> Note: Existing rewards accounts were converted from a points based system to a cash back system.</p>
                 </div>
                <div class="">
                    ${creditSummary && creditSummary?.include?.credit_details.length ? this.getCreditHistoryHtml(creditSummary.include.credit_details) : ''}
                </div>
        </div>
        `
        },
        getCreditHistoryHtml(history) {
            return `
        <div class="creditRewardHistoryWrapper">
            <div class="creditRewardHistoryList">
                ${this.getCreditHistoryItemsHtml(history)}
            </div>
            <div class="tableShow mb-2" id="loyaltylion">
                ${this.getCreditHistoryTableHtml(history)}
            </div>
        </div>
        `
        },
        getCreditHistoryTableHtml(history = []) {
            let historyItems = '';
            if (!history.length) {
                historyItems = `<tr><td colspan="4" style="text-align: center;">You have not earned cash-back rewards yet.</td></tr>`
            } else {
                historyItems = history.map(this.getCreditRewardHistoryTableItemHtml).join('');
            }
            return `
        <table class="lion-history-table " style="width:100%">
            <thead>
                <tr>
                    <th class="lion-history-table__header-cell">Date</th>
                    <th class="lion-history-table__header-cell">Name</th>
                    <th class="lion-history-table__header-cell">Amount</th>
                    <th class="lion-history-table__header-cell lion-history-table__header-cell--centre-aligned">Type</th>
                </tr>
            </thead>
            <tbody>
                ${historyItems}
            </tbody>
        </table>
        `
        },
        getCreditRewardHistoryTableItemHtml(item) {
            // Sample data for demonstration; you can replace this with actual item details as needed
            const date = changeUSADateFormate(item.created_at);
            const number = `#${item.id}`;
            const name = item.name;
            const badge = item.type;
            const amount = `$${item.available_balance}`;
            return `
             <tr class="lion-history-table__row">
                <td class="lion-history-table__row-cell lion-history-table__row-date">${date}</td>
                <td class="lion-history-table__row-cell">${name ? name : '-'} <br> ${number ? number : ''}</td>
                <td class="lion-history-table__row-cell">${amount}</td>
                <td class="lion-history-table__row-cell lion-history-table__row-status">
                    <div class="lion-history-table__bubble lion-history-state-bubble lion-history-state-bubble--declined">
                        ${badge}
                    </div>
                </td>
            </tr>
         `
        },
        getCreditHistoryItemsHtml() {
            return ''
            const historyItems = [1, 2, 3, 4].map(this.getCreditRewardHistoryItemHtml).join('');
            return `
        <div class="creditRewardHistoryItemsWrapper">
             ${historyItems}
             <div class="paginationWrapper">
                <nav aria-label="Page navigation example" style="display:flex">
                    <ul class="pagination mx-auto m-0">
                        <li class="page-item disabled"><a class="page-link" href="#" tabindex="-1" aria-disabled="true">Previous</a></li>
                        <li class="page-item"><a class="page-link" href="#">1</a></li>
                        <li class="page-item active" aria-current="page"><a class="page-link" href="#">2</a></li>
                        <li class="page-item"><a class="page-link" href="#">3</a></li>
                        <li class="page-item"><a class="page-link" href="#">Next</a></li>
                    </ul>
                </nav>
             </div>
        </div>
        `
        },
        getCreditRewardHistoryItemHtml(item) {
            // Sample data for demonstration; you can replace this with actual item details as needed
            const date = "1, May 2023, 6:08PM";
            const number = `#1234${item}`;
            const name = "Customer Support";
            const badge = "manual";
            const amount = "$2.00";

            return `
            <div class="creditRewardHistoryItem">
                <div class="creditItemRow">
                   <span class="creditDate">${date}</span>
                   <span class="creditNumber">${number}</span>
                </div>
                <div class="creditItemRow">
                   <div>
                        <span class="creditName">${name}</span>
                        <span class="creditBadge">${badge}</span>
                   </div>
                    <span class="creditAmount">${amount}</span>
                </div>
            </div>
        `;
        },
        getCreditHeaderHTML(balance) {
            return `
         <div class="creditRewardHeader totalCredit">
            <div class="currentPointHeading">Loyalty Card</div>
            <div class="currentPointsText">Available Balance</div>
            <div class="currentPoints">$${balance}</div>
            <span class="currentPointsTag">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><defs><style>.cls-1{fill:white;}</style></defs><title>Asset 47ldpi</title><g id="Layer_2" data-name="Layer 2"><g id="layer_1-2" data-name="layer 1"><path class="cls-1" d="M9,45H1a1,1,0,0,1-1-1V30a1,1,0,0,1,1-1H9a1,1,0,0,1,1,1V44A1,1,0,0,1,9,45ZM2,43H8V31H2Z"/><path class="cls-1" d="M27,48l-.22,0-18-4,.44-2L26.87,46,46,36.38V35.24L33.21,38l-.42-2,14-3A1,1,0,0,1,48,34v3a1,1,0,0,1-.55.89l-20,10A1,1,0,0,1,27,48Z"/><path class="cls-1" d="M24,41a.8.8,0,0,1-.27,0l-7-2L17.27,37,24.08,39,32,38.1V36H25a1,1,0,0,1-.45-.11L16.76,32H9V30h8a1,1,0,0,1,.45.11L25.24,34H33a1,1,0,0,1,1,1v4a1,1,0,0,1-.89,1l-9,1Z"/><rect class="cls-1" x="4" y="39" width="2" height="2"/><path class="cls-1" d="M29,26a4,4,0,0,1-4-4h2a2,2,0,1,0,2-2,4,4,0,1,1,4-4H31a2,2,0,1,0-2,2,4,4,0,0,1,0,8Z"/><rect class="cls-1" x="28" y="25" width="2" height="3"/><rect class="cls-1" x="28" y="10" width="2" height="3"/><path class="cls-1" d="M29,31A12,12,0,1,1,41,19,12,12,0,0,1,29,31ZM29,9A10,10,0,1,0,39,19,10,10,0,0,0,29,9Z"/><rect class="cls-1" x="40" y="18" width="7" height="2"/><rect class="cls-1" x="11" y="18" width="7" height="2"/><rect class="cls-1" x="28" y="30" width="2" height="4"/><rect class="cls-1" x="28" y="1" width="2" height="7"/><rect class="cls-1" x="35.75" y="7.75" width="7" height="2" transform="translate(5.31 30.32) rotate(-45)"/><rect class="cls-1" x="16.13" y="27.89" width="5.97" height="2" transform="translate(-14.83 21.97) rotate(-45)"/><path class="cls-1" d="M41.73,32.73a1,1,0,0,1-.71-.29l-5-4.95,1.42-1.42,4.22,4.22a17,17,0,1,0-26.85-1.84L13.2,29.56a19,19,0,1,1,29.24,2.88A1.05,1.05,0,0,1,41.73,32.73Z"/><rect class="cls-1" x="17.75" y="5.25" width="2" height="7" transform="translate(-0.69 15.82) rotate(-45)"/></g></g></svg>
            </span>
        </div>
        `
        },
        handleCreditFooterSlot() {
            console.log("Footer slot handler called."); // Log when the footer slot handler is invoked
            $('#creditFooterSlot').show();
        },
    };

    const changeUSADateFormate = (dateString) => {
        const date = new Date(dateString);  // Create a Date object from the string
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');  // Months are 0-indexed
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }

    // Initialize the handler
    window.creditSlotHandler = creditSlotHandler
}

